import { AUTHOR_CHANGED, CATEGORY_CHANGED, SEARCH_BLOGS } from "./actionTypes";
import { initialState } from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTHOR_CHANGED:
      if (state.author) return { ...state, author: "" };
      else return { ...state, author: action.payload };
    case CATEGORY_CHANGED:
      if (state.category.includes(action.payload)) {
        return {
          ...state,
          category: state.category.filter((ct) => ct !== action.payload),
        };
      } else return { ...state, category: [...state.category, action.payload] };
    case SEARCH_BLOGS:
      return { ...state, searchText: action.payload };
    default:
      return state;
  }
};

export default reducer;
